/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import SkeletonText from '../SkeletonText/SkeletonText.js';
import ButtonSkeleton from '../Button/Button.Skeleton.js';
import { usePrefix } from '../../internal/usePrefix.js';

var _SkeletonText, _ButtonSkeleton;
function FileUploaderSkeleton(_ref) {
  let {
    className,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cx(`${prefix}--form-item`, className)
  }, rest), _SkeletonText || (_SkeletonText = /*#__PURE__*/React__default.createElement(SkeletonText, {
    heading: true,
    width: "100px"
  })), /*#__PURE__*/React__default.createElement(SkeletonText, {
    width: "225px",
    className: `${prefix}--label-description`
  }), _ButtonSkeleton || (_ButtonSkeleton = /*#__PURE__*/React__default.createElement(ButtonSkeleton, null)));
}
FileUploaderSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string
};

export { FileUploaderSkeleton, FileUploaderSkeleton as default };
